import * as moment from 'moment';

export class OfficeEquipmentResult {
    public id: number = 0;
    public employeeId: number = 0;
    public employeeFullName: string = '';
    public officeEquipmentTypeId: number = 0;
    public officeEquipmentTypeName: string = '';
    public officeEquipmentModelId: number = 0;
    public officeEquipmentModelName: string = '';
    public officeEquipmentBrandId: number = 0;
    public officeEquipmentBrandName: string = '';
    public code: string = '';
    public givenDateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public returnDateTime?: moment.Moment | null = null;
    public isDeleted: boolean = false;
}
